<div
  class="mw-select"
  [class.mw-select--has-value]="hasValue"
  [class.mw-select--read-only]="readonly"
  [class.mw-select--invalid]="formControl.invalid && formControl.touched"
  [class.mw-select--searchable]="searchable"
>
  <ng-select
    #select
    [items]="items"
    [clearable]="clearable"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [placeholder]="placeholder"
    [searchable]="false"
    [groupBy]="groupBy"
    [selectableGroup]="selectableGroup"
    [multiple]="multiple"
    [closeOnSelect]="!multiple"
    [loading]="loading"
    [minTermLength]="minTermLength"
    [typeahead]="typeahead"
    [typeToSearchText]="typeToSearchText"
    [formControl]="formControl"
    [appendTo]="appendTo"
    [readonly]="readonly"
    (open)="onDropDownOpen()"
    (close)="onDropDownClose()"
    (scrollToEnd)="scrollToEnd.emit()"
    (scroll)="scrollPanel.emit($event)"
    (remove)="remove.emit()"
    (add)="add.emit()"
    (clear)="clear.emit()"
  >
    <ng-template
      ng-multi-label-tmp
      let-items="items"
      let-clear="clear"
      *ngIf="multiple"
    >
      <div class="mw-select__multi-value" *ngIf="!selectedAll">
        <div
          class="ng-value"
          *ngFor="let item of items | slice: 0:1"
          [ngClass]="item[bindClassName]"
        >
          <span class="ng-value-label">{{ item[bindLabel] }}</span>
        </div>
        <div
          class="ng-value mw-select__multi-value-others"
          *ngIf="items.length > 1"
        >
          <span class="ng-value-label">
            {{
              'COMPONENT.SELECT.others' | translate: { value: items.length - 1 }
            }}
          </span>
        </div>
      </div>
      <div class="mw-select__multi-value" *ngIf="selectedAll">
        {{ 'COMPONENT.SELECT.all' | translate }}
      </div>
    </ng-template>
    <ng-template ng-header-tmp>
      <div class="mw-select__search-field">
        <input
          #searchInputElement
          [(ngModel)]="searchInput"
          [placeholder]="'COMPONENT.SELECT.search' | translate"
          (keydown.enter)="onSearchFieldEnterKeyDown($event)"
          cdkFocusInitial
          (input)="onFilter($event)"
          class="mw-select__search-input"
        />

        <div *ngIf="loading" class="mw-select__loading-spinner">
          <mat-spinner color="accent" diameter="14"></mat-spinner>
        </div>

        <span
          matSuffix
          aria-hidden="true"
          class="ng-clear"
          *ngIf="searchInput"
          (click)="onClearSearchInput()"
        >
          ×
        </span>
        <span matSuffix class="ng-arrow-wrapper">
          <span class="ng-arrow"></span>
        </span>
      </div>
      <div
        class="mw-select__select-all"
        *ngIf="
          multiple &&
          select.itemsList.filteredItems.length > 0 &&
          allowSelectAll
        "
      >
        <mat-checkbox
          [checked]="selectedAll"
          (change)="onSelectAll($event)"
          [disableRipple]="true"
          [indeterminate]="indeterminateSelectAll"
        >
          {{ 'COMPONENT.SELECT.all' | translate }}
        </mat-checkbox>
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <div class="mw-select__option">
        <div class="mw-select__option-label" *ngIf="multiple">
          <mat-checkbox
            [disabled]="item.disabled"
            [disableRipple]="true"
            [checked]="isSelected(item)"
            (change)="onCheckboxChange($event, item)"
            (click)="$event.stopPropagation()"
            class="mw-select__checkbox"
            [ngClass]="item[bindClassName]"
          >
            {{ item[bindLabel] }}
          </mat-checkbox>
        </div>
        <div
          class="mw-select__option-label"
          *ngIf="!multiple"
          [ngClass]="item[bindClassName]"
        >
          {{ item[bindLabel] }}
        </div>
        <div class="mw-select__option-caption" *ngIf="bindCaptionLabel">
          {{ item[bindCaptionLabel] }}
        </div>
      </div>
    </ng-template>
    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled mw-select__no-result-text">
        {{ 'COMPONENT.SELECT.no_results' | translate }}
      </div>
    </ng-template>
    <ng-template ng-optgroup-tmp let-item="item" let-index="index">
      <div
        class="mw-select__option-group-label mw-select__option-group-label--selectable"
        *ngIf="multiple && selectableGroup"
      >
        <mat-checkbox
          [checked]="isGroupSelected(item)"
          [disableRipple]="true"
          [indeterminate]="isIndeterminateGroup(item)"
          (change)="onGroupCheckboxChange($event, item)"
          (click)="$event.stopPropagation()"
          class="mw-select__checkbox"
        >
          {{ item[groupBy] }}
        </mat-checkbox>
      </div>
      <div
        class="mw-select__option-group-label"
        *ngIf="!multiple || !selectableGroup"
      >
        {{ item[groupBy] }}
      </div>
    </ng-template>
    <ng-template ng-loadingtext-tmp>
      <div class="mw-select__loading-text ng-option">
        {{ 'COMPONENT.SELECT.loading' | translate }}
      </div>
    </ng-template>

    <ng-template ng-loadingspinner-tmp></ng-template>

    <ng-template *ngIf="footerTemplate" ng-footer-tmp>
      <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
    </ng-template>
  </ng-select>
</div>
